document.addEventListener('DOMContentLoaded', () => {
    const SCROLL_TOP_BREAKPOINT = 208;
    const SHADOW_BREAKPOINT = 1;

    const body = document.body;
    let lastScrollPosition = 0;

    lastScrollPosition = getScrollPosition();
    checkScrollState();

    document.addEventListener('scroll', checkScrollState);

    function checkScrollState() {
        if (document.documentElement.classList.contains('fixed')) {
            return;
        }

        const currentScrollPosition = getScrollPosition();

        if (currentScrollPosition > SHADOW_BREAKPOINT) {
            body.classList.add('has-shadow');
        } else {
            body.classList.remove('has-shadow');
        }

        if (currentScrollPosition <= SCROLL_TOP_BREAKPOINT) {
            body.classList.add('not-scrolled');
            body.classList.remove('header-scrolled', 'header-scrolled-up');
        } else if (currentScrollPosition > lastScrollPosition) {
            body.classList.add('header-scrolled');
            body.classList.remove('not-scrolled', 'header-scrolled-up');
        } else {
            body.classList.add('header-scrolled-up');
            body.classList.remove('not-scrolled', 'header-scrolled');
        }

        lastScrollPosition = currentScrollPosition;
    }

    function getScrollPosition() {
        return window.pageYOffset || document.documentElement.scrollTop;
    }
});
